import script from "./ModalFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalFooter.vue?vue&type=script&lang=ts&setup=true"

import "./ModalFooter.vue?vue&type=style&index=0&id=420df09c&lang=scss"

const __exports__ = script;

export default __exports__